import { Carousel, ComponentInfo } from '@components';
import React from 'react';

export const IntroPlaceholder: React.FC = () => {
	return (
		<ComponentInfo name="IntroPlaceholder">
			<Carousel />
		</ComponentInfo>
	);
};
